import { Region } from './countriesConfig';

export const POLISH_REGIONS = [
    {
        name: 'Dolnośląskie',
        code: 'PL-02',
        provinces: [{ name: 'Dolnośląskie', code: 'DS' }],
    },
    {
        name: 'Kujawsko-Pomorskie',
        code: 'PL-04',
        provinces: [{ name: 'Kujawsko-Pomorskie', code: 'KP' }],
    },
    {
        name: 'Lubelskie',
        code: 'PL-06',
        provinces: [{ name: 'Lubelskie', code: 'LU' }],
    },
    {
        name: 'Lubuskie',
        code: 'PL-08',
        provinces: [{ name: 'Lubuskie', code: 'LB' }],
    },
    {
        name: 'Łódzkie',
        code: 'PL-10',
        provinces: [{ name: 'Łódzkie', code: 'LD' }],
    },
    {
        name: 'Małopolskie',
        code: 'PL-12',
        provinces: [{ name: 'Małopolskie', code: 'MP' }],
    },
    {
        name: 'Mazowieckie',
        code: 'PL-14',
        provinces: [{ name: 'Mazowieckie', code: 'MZ' }],
    },
    {
        name: 'Opolskie',
        code: 'PL-16',
        provinces: [{ name: 'Opolskie', code: 'OP' }],
    },
    {
        name: 'Podkarpackie',
        code: 'PL-18',
        provinces: [{ name: 'Podkarpackie', code: 'PK' }],
    },
    {
        name: 'Podlaskie',
        code: 'PL-20',
        provinces: [{ name: 'Podlaskie', code: 'PD' }],
    },
    {
        name: 'Pomorskie',
        code: 'PL-22',
        provinces: [{ name: 'Pomorskie', code: 'PM' }],
    },
    {
        name: 'Śląskie',
        code: 'PL-24',
        provinces: [{ name: 'Śląskie', code: 'SL' }],
    },
    {
        name: 'Świętokrzyskie',
        code: 'PL-26',
        provinces: [{ name: 'Świętokrzyskie', code: 'SK' }],
    },
    {
        name: 'Warmińsko-Mazurskie',
        code: 'PL-28',
        provinces: [{ name: 'Warmińsko-Mazurskie', code: 'WM' }],
    },
    {
        name: 'Wielkopolskie',
        code: 'PL-30',
        provinces: [{ name: 'Wielkopolskie', code: 'WP' }],
    },
    {
        name: 'Zachodniopomorskie',
        code: 'PL-32',
        provinces: [{ name: 'Zachodniopomorskie', code: 'ZP' }],
    },
] as const satisfies [Region, ...Region[]];
